<template>
  <div class="large-image" :class="[{'large-image--is-landing': isLanding}]">
    <div class="large-image__content" :class="[{'large-image__content--is-landing': isLanding}]">
      <div class="large-image__image-wrapper">
        <div class="large-image__image" :class="[{'large-image__image--is-landing': isLanding}]">
          <ModuleImage :imageUrl="image" :altText="altText" :placeholderUrl="placeholderImage" :lazyLoad="!isLanding"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectionLargeImage',
  props: {
    image: String,
    placeholderImage: String,
    altText: String,
    isLanding: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './large-image'
</style>



// WEBPACK FOOTER //
// src/components/SectionLargeImage/SectionLargeImage.vue